document.addEventListener('DOMContentLoaded', function () {

    // 🔍 Elementos
    const filterButtons = document.querySelectorAll('.categoria');
    const posts = document.querySelectorAll('.post-item');
    const rowNoticias = document.querySelector('.noticias .row');

    // Variável para armazenar categoria ativa
    let categoriaAtiva = 'todos';

    // 🔄 Função: Filtrar posts
    function filtrarPosts(categoria) {
        let postsVisiveis = false;

        posts.forEach(post => {
            const postCategoria = post.getAttribute('data-category');

            // Se for "todos" ou a categoria bater, mostra
            if (categoria === 'todos' || postCategoria === categoria) {
                post.classList.remove('hide');
                post.classList.add('show');
                post.style.display = ''; // Garante que volte ao fluxo
                postsVisiveis = true;

                // Re-inicializa AOS para animar a entrada
                if (typeof AOS !== 'undefined') {
                    AOS.refreshHard();
                }
            } else {
                post.classList.remove('show');
                post.classList.add('hide');
                // Delay para remover do fluxo após animação
                setTimeout(() => {
                    if (post.classList.contains('hide')) {
                        post.style.display = 'none';
                    }
                }, 400); // Mesmo tempo da transição CSS
            }
        });
        
        // Mostra mensagem se nenhum post for encontrado
        toggleNoResults(postsVisiveis);
    }

    // 🔄 Função: Mostrar/Esconder mensagem "Nenhum resultado"
    function toggleNoResults(dontShow) {
        let noResults = document.querySelector('.no-results');

        if (!noResults) {
            noResults = document.createElement('div');
            noResults.className = 'no-results';
            noResults.textContent = 'Nenhum post encontrado nesta categoria.';
            rowNoticias.appendChild(noResults);
        }
        
        if (dontShow === true) {
            noResults.classList.remove('d-none');
            noResults.classList.add('d-none');
        } else {
            noResults.classList.remove('d-none');
        }
    }

    // 🎯 Event Listeners: Clique nos botões de filtro
    filterButtons.forEach(button => {
        button.addEventListener('click', function () {
            // Remove active de todos e adiciona no clicado
            filterButtons.forEach(btn => btn.classList.remove('active'));
            this.classList.add('active');

            // Pega o valor diretamente do atributo data-filter (independente do idioma)
            const categoria = this.getAttribute('data-filter');
            categoriaAtiva = categoria;

            filtrarPosts(categoria);
        });
    });

    // ✅ Inicialização: Garante que o botão com data-filter="todos" comece ativo
    const btnTodos = Array.from(filterButtons).find(btn =>
        btn.getAttribute('data-filter') === 'todos'
    );
    if (btnTodos) {
        btnTodos.classList.add('active');
    }

    // ✅ Debug
    console.log('✅ Filtro de posts inicializado!');
    console.log('📦 Posts encontrados:', posts.length);
    console.log('🏷️ Categorias disponíveis:', [...new Set([...posts].map(p => p.getAttribute('data-category')))]);
});